export default __webpack_public_path__ + "static/media/pnsv_web_FraseFooter.eb7a37b9.png";